/**
 * Product Service - API client for product operations
 * Uses shared API client from @/shared/api
 */

import api from "@/shared/api";

/**
 * Get all products with optional filters
 * @param {Object} filters - Filter options (category, search, active)
 * @returns {Promise<{success: boolean, data?: Array, error?: string}>}
 */
export const getProducts = async (filters = {}) => {
  try {
    const params = {};
    if (filters.category) params.category = filters.category;
    if (filters.search) params.search = filters.search;
    if (filters.active === true || filters.active === false) {
      params.active = filters.active;
    }

    const response = await api.get("/products", { params });
    return {
      success: response.success !== false,
      data: response.data || [],
      error: response.error,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to fetch products",
    };
  }
};

/**
 * Get product by ID
 * @param {string} id - Product ID
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export const getProductById = async (id) => {
  try {
    const response = await api.get(`/products/${id}`);
    return {
      success: response.success !== false,
      data: response.data,
      error: response.error,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to fetch product",
    };
  }
};

/**
 * Create a new product
 * @param {Object} productData - Product data
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export const createProduct = async (productData) => {
  try {
    const response = await api.post("/products", productData);
    return {
      success: response.success !== false,
      data: response.data,
      error: response.error,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to create product",
    };
  }
};

/**
 * Update product by ID
 * @param {string} id - Product ID
 * @param {Object} updates - Update data
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export const updateProduct = async (id, updates) => {
  try {
    const response = await api.put(`/products/${id}`, updates);
    return {
      success: response.success !== false,
      data: response.data,
      error: response.error,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to update product",
    };
  }
};

/**
 * Delete product (soft delete - sets active=false)
 * @param {string} id - Product ID
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export const deleteProduct = async (id) => {
  try {
    const response = await api.delete(`/products/${id}`);
    return {
      success: response.success !== false,
      data: response.data,
      error: response.error,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to delete product",
    };
  }
};






